import { colors } from './';

const borderRadiusValue = '3px';
const borderRadius = `border-radius: ${borderRadiusValue};`;

export const button = `
  ${borderRadius};
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  fill: currentcolor;
  padding: 1em 2em;
  transition: all 133ms ease-out;
  box-shadow: none;

  :hover {
    transform: translateY(-1px);
  }

  :focus {
    outline: none;
  }

  [disabled],
  &.disabled {
    &,
    &:hover {
      background: ${colors.grey100};
      color: ${colors.grey500};
      cursor: default;
      transform: translateY(0);
      box-shadow: none;
      border: 1px solid ${colors.grey100};
    }
  }

  &.full-width {
    width: 100%;
  }

`;

export const input = `
  border: none;
  appearance: none;

  :focus {
    outline: none;
  }
`;

export default {
  button,
  input,
  borderRadiusValue,
};
